import { IAutoCompleteItem } from '../api/DashboardTypes';
import { TickData } from '../api/Types';

/* SET CURRENT TRADING DAY */
export const SET_CURRENT_TRADING_DAY = 'SET_CURRENT_TRADING_DAY';

interface ISetCurrentTradingDayAction {
    type: typeof SET_CURRENT_TRADING_DAY,
    payload: {
        newTradingDay: string,
        skipPushingToHistory: boolean
    }
}

/* SET DAY RANGE */
export const SET_DAY_RANGE = 'SET_DAY_RANGE';

interface ISetDayRangeAction {
    type: typeof SET_DAY_RANGE,
    payload: {
        fromDate: string,
        toDate: string,
        skipPushingToHistory: boolean
    }
}

/* REQUEST AUTOCOMPLETE ITEMS */
export const REQUEST_AUTOCOMPLETE_ITEMS_WAITING = 'REQUEST_AUTOCOMPLETE_ITEMS_WAITING';
export const REQUEST_AUTOCOMPLETE_ITEMS_SUCCESS = 'REQUEST_AUTOCOMPLETE_ITEMS_SUCCESS';
export const REQUEST_AUTOCOMPLETE_ITEMS_FAILURE = 'REQUEST_AUTOCOMPLETE_ITEMS_FAILURE';

interface IRequestAutocompleteItemsWaitingAction {
    type: typeof REQUEST_AUTOCOMPLETE_ITEMS_WAITING
}

interface IRequestAutocompleteItemsSuccessAction {
    type: typeof REQUEST_AUTOCOMPLETE_ITEMS_SUCCESS,
    autoCompleteItems: IAutoCompleteItem[]
}

interface IRequestAutocompleteItemsFailureAction {
    type: typeof REQUEST_AUTOCOMPLETE_ITEMS_FAILURE,
    error: string
}

/* SET SELECTED TICK */
export const SET_SELECTED_TICK = 'SET_SELECTED_TICK';

interface ISetSelectedTickAction {
    type: typeof SET_SELECTED_TICK,
    payload: TickData | null
}

/* SET CHECKED ADDITIONAL TIMESTAMPS */
export const SET_CHECKED_ADDITIONAL_TICK_IDS = 'SET_CHECKED_ADDITIONAL_TICK_IDS';

export interface ISetCheckedAdditionalTickIdsAction {
    type: typeof SET_CHECKED_ADDITIONAL_TICK_IDS;
    payload: { checkedAdditionalTickIds: string[] };
}

export type DashboardActions =
ISetCurrentTradingDayAction
| ISetDayRangeAction
| IRequestAutocompleteItemsWaitingAction
| IRequestAutocompleteItemsSuccessAction
| IRequestAutocompleteItemsFailureAction
| ISetSelectedTickAction
| ISetCheckedAdditionalTickIdsAction;